/** @jsxImportSource @emotion/react */
import { css, Global } from '@emotion/react'
import styled from '@emotion/styled'
import { observer } from 'mobx-react-lite'
import { FC } from 'react'
import { ToastContainer } from 'react-toastify'
import { rpMediaQueries, theme } from '../../core/theme'
import { useRussianPokerStore } from '../../providers/RussianPokerProvider'
import {
  Balance,
  LimitsBtn,
  LogoutBtn,
  NoticeIcon,
  PaymentsTable,
  ToggleSoundBtn,
  Typography,
} from '../index'
import { Container, Divider, Panel } from './styles'

const StyledToastWrapper = styled(ToastContainer)`
  position: absolute;
  top: 100%;
  left: 0;
  padding: 0;
  z-index: 1;
  right: 0;
  transform: translateX(0);
  display: flex;
  flex-direction: column;
  width: 160px;

  ${rpMediaQueries.tablet} {
    width: 275px;
  }
`

const PanelWrapper = styled.div`
  position: relative;
`

const StyledSessionID = styled.div`
  margin-top: 5px;
  margin-bottom: 5px;
`

const ToastGlobalStyles = () => (
  <Global
    styles={css`
      #prp2box {
        position: absolute;
        display: flex;
        right: -12px;
        top: 0;

        .Toastify__toast {
          padding: 5px 4px 5px 7px;
          border-radius: 5px;
          border: 1px solid rgba(255, 255, 255, 0.1);
          margin-bottom: 5px;
          min-height: auto;
        }

        .Toastify__toast-body {
          padding: 0;

          font-size: 8px;
          font-weight: 400;
          line-height: normal;

          ${rpMediaQueries.tablet} {
            font-size: 12px;
          }

          ${rpMediaQueries.desktop} {
            font-size: 14px;
          }
        }

        .Toastify__toast-icon {
          margin-inline-end: 3px;
          width: auto;
          position: relative;
          top: 1px;
        }

        .Toastify__toast--warning,
        .Toastify__toast--error,
        .Toastify__toast--info,
        .Toastify__toast--success {
          width: auto;
          color: ${theme.rpTheme.colors.gold1};
          background: linear-gradient(
              269deg,
              rgba(255, 255, 255, 0.1) 0.57%,
              rgba(255, 255, 255, 0.05) 31.35%
            ),
            rgba(0, 0, 0, 0.6);
        }
      }
    `}
  />
)

export const TopActionBar: FC = observer(() => {
  const {
    game: { sessionId },
    uiStore: { showPaymentsTable },
  } = useRussianPokerStore()

  return (
    <Container showPaymentsTable={showPaymentsTable}>
      <PanelWrapper>
        <Panel>
          <LogoutBtn />
          <Divider />
          <ToggleSoundBtn />
          <Divider />
          <Balance />
          <Divider />
          <LimitsBtn />
        </Panel>
        <StyledSessionID>
          <Typography
            variant="text5"
            color="white"
            css={css`
              opacity: 0.5;
            `}>
            ID {sessionId}
          </Typography>
        </StyledSessionID>
        <ToastGlobalStyles />
        <StyledToastWrapper
          containerId="prp2box"
          position="top-center"
          enableMultiContainer
          autoClose={3000}
          newestOnTop
          limit={3}
          closeOnClick
          closeButton={false}
          pauseOnHover
          draggable={false}
          className="toast-container-pageX"
          toastClassName="toast-pageX"
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
          icon={({ type }) => {
            return (
              <NoticeIcon
                color="gold1"
                size={{
                  mobile: '8px',
                  tablet: '12px',
                  desktop: '10px',
                }}
              />
            )
            // switch (type) {
            //   case 'info':
            //     return <RevertIcon />
            //   case 'error':
            //     return <RevertIcon />
            //   case 'success':
            //     return <RevertIcon />
            //   case 'warning':
            //     return (
            //       <NoticeIcon
            //         color="gold1"
            //         size={{
            //           mobile: '8px',
            //           tablet: '12px',
            //           desktop: '10px',
            //         }}
            //       />
            //     )
            //   default:
            //     return null
            // }
          }}
        />
      </PanelWrapper>
      <PaymentsTable show={showPaymentsTable} />
    </Container>
  )
})
